export function useAccommodation(code: MaybeRefOrGetter<string>) {
  const webccApi = useWebccApi()

  async function getImages(season: Season) {
    return (
      (await webccApi.accommodationImages(toValue(code), season)).data.value ??
      []
    )
  }

  return { getImages }
}
